import type { ProcessContent } from "../../types/page-content";

interface Props {
  content: ProcessContent;
  sectionNumber?: string;
}

export default function ProcessSection({ content, sectionNumber = "04" }: Props) {
  return (
    <section className="bg-[#111111] py-28 lg:py-40 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.03] bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/916d37371e1878db6c9ad2ae4db82404.jpg')",
        }}
      />
      <div className="absolute right-6 top-10 hidden xl:block">
        <span className="font-heading text-white/[0.03] text-[180px] leading-none select-none">{sectionNumber}</span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-14">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-20">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-0.5 bg-safety-500" />
              <span className="font-body text-safety-500 text-xs uppercase tracking-widest2 font-700">{content.eyebrow}</span>
            </div>
            <h2 className="font-heading text-white text-6xl lg:text-8xl tracking-display leading-none">
              {content.heading}
            </h2>
          </div>
          <p className="font-body text-asphalt-300 text-sm leading-relaxed max-w-sm">{content.subheading}</p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line desktop */}
          <div className="hidden lg:block absolute top-12 left-12 right-12 h-px bg-asphalt-600 z-0" />

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            {content.steps.map((step, idx) => (
              <div key={step.num} className="relative flex flex-col items-start lg:items-center text-left lg:text-center gap-5">
                {/* Circle */}
                <div className="relative z-10 w-24 h-24 flex items-center justify-center border border-safety-500 bg-[#111111] flex-shrink-0">
                  <div className="absolute -top-2.5 -left-2.5 font-heading text-safety-500 text-xs tracking-widest">
                    {step.num}
                  </div>
                  <i className={`${step.icon} text-safety-500 text-3xl`} />
                </div>

                <div className="bg-[#191919] border border-asphalt-600 p-6 w-full">
                  <h3 className="font-heading text-white text-2xl tracking-display mb-2">{step.title}</h3>
                  <p className="font-body text-asphalt-300 text-xs leading-relaxed">{step.description}</p>
                </div>

                {/* Arrow between steps (mobile only) */}
                {idx < content.steps.length - 1 && (
                  <div className="lg:hidden w-px h-6 bg-asphalt-600 mx-auto" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
